import React, { useState, useEffect } from "react";
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Modal,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  IconButton,
  Grid, Stack, TablePagination
} from "@mui/material";
import http from "../../utils/http-common";
import { toast } from "react-toastify";
import { styled } from '@mui/material/styles';
import { Edit as EditIcon, ChangeCircle as ChangeCircleIcon } from '@mui/icons-material';
const StatusButton = styled(Box)(({ status }) => ({
  padding: '2px 8px',
  borderRadius: '20px',
  fontSize: '12px',
  fontWeight: 600,
  backgroundColor: 'transparent',
  border: `1px solid ${getStatusColor(status)}`,
  color: getStatusColor(status),
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '24px',
  minWidth: '90px',
  textTransform: 'capitalize'
}));

const getStatusColor = (status) => {
  const statusColors = {
    'Open': '#2196F3',        // Blue
    'In Progress': '#FF9800', // Orange
    'Pending': '#FFA726',     // Light Orange
    'Requested': '#666666',   // Gray
    'Schedule': '#9C27B0',    // Purple
    'Technical': '#00ACC1',   // Cyan
    'Completed': '#4CAF50',   // Green
    'Compliance': '#F44336'      // Red
  };
  return statusColors[status] || '#666666'; // Default gray if status not found
};
export default function Constraints () {
    const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(10);

  // Add pagination handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
const [constraintModalOpen, setConstraintModalOpen] = useState(false);

const [constraintData, setConstraintData] = useState({
  id: "",
  name: "",
  status: "Schedule"
});


const [constraints, setConstraints] = useState([]);
const planId = localStorage.getItem("plan_id");
useEffect(() => {
    fetchPlanData();
  }, [planId]);
const fetchPlanData = async () => {
    try {
      const response = await http.get(`/master_service/get_project/plan/summary/${planId}`);
      if (response.status === 200) {
        const data = response.data.constraints.map(item => ({
      id: item.const_id,
      name: item.name,
      status: item.status
        }));
        setConstraints(data);
      }
    } catch (error) {
      console.error("Error fetching user data", error);
    }
  };

const [filters, setFilters] = useState({
  issues: '',
  assumptions: '',
  risks: '',
  dependencies: '',
  constraints: ''
});
const filterConstraints = () => {
  return constraints.filter(constraint =>
    Object.values(constraint).some(value =>
      value ? value.toString().toLowerCase().includes(filters.constraints.toLowerCase()) : false
    )
  );
};
const handleInputChange4 = (field, value) => {
  setConstraintData(prev => ({ ...prev, [field]: value }));
};
const [expandedSections, setExpandedSections] = useState({});
const toggleSection = (sectionId) => {
  setExpandedSections(prev => ({
    ...prev,
    [sectionId]: !prev[sectionId]
  }));
};
const handleFilterChange = (table, value) => {
  setFilters(prev => ({
    ...prev,
    [table]: value
  }));
};
 const handleEdit = (constraint) => {
    setConstraintData({
      id: constraint.id,
      name: constraint.name,
      plan_id: planId,
      status: constraint.status,
    });
    setConstraintModalOpen(true);
  };
  const handleStatusUpdate = async (constraint) => {

    const nextStatus = getNextStatus(constraint.status);
    try {
      const payload = {
        const_id: constraint.id,
        "name": constraint.name,
        "plan_id": planId,
        status: nextStatus,
      };
      const response = await http.post('/master_service/create_update/constraint', payload);
      if (response.status === 200 || response.status === 201) {
        toast.success("Status updated successfully");
        fetchPlanData();
      }
    } catch (error) {
      toast.error("Failed to update status");
    }
  };

  // Helper function to determine next status
  const getNextStatus = (currentStatus) => {
    const statusFlow = {
        'Open': 'Technical',
      'Technical': 'Technical',
      'Compliance': 'Compliance',
      'Schedule': 'Schedule'
    };
    return statusFlow[currentStatus] || 'Open';
  };
  const handleSave = async (data, closeModal, resetData) => {
    try {
      const payload = {
        const_id: data.id,
        "name": data.name,
        "plan_id": planId,
        "status": data.status
      }
      const response = await http.post('/master_service/create_update/constraint', payload);
      if (response.status === 201 || response.status === 200) {
        toast.success("Data saved successfully");
        closeModal(false);
        resetData();
        fetchPlanData();
      }
    } catch (error) {
      toast.error("Failed to save data1");
    }
  };
return (
    <Container maxWidth={false} sx={{ width: "100%", p: 1 }}>

 <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', bgcolor: '#F7F8F8', p: 0.5, mb: 0.2 }}>
   <Box sx={{display:"flex", justifyContent:"flex-start", alignItems:"center"}}>
    <Typography style={{fontWeight: "600"}}>Constraints</Typography>
    <Typography sx={{ ml: 1, fontSize: '12px' }}>({constraints.length} Constraints)</Typography>
  </Box>
  <Box sx={{display:"flex", justifyContent:"flex-end", alignItems:"center"}}>
<TextField
      size="small"
      placeholder="Search here..."
      value={filters.constraints}
      onChange={(e) => handleFilterChange('constraints', e.target.value)}
      sx={{ ml: 2, mr:1, minWidth: '200px' }}
    />
    <Button
  onClick={() => setConstraintModalOpen(true)}
  sx={{ 
            minWidth: '24px',
            width: '26px',
            height: '26px',
            p: 0,
            mr: '4px',
            color: '#FFF',
            border: 'none',
            backgroundColor: '#FF2800',
            '&:hover': {
                backgroundColor: '#FF2800',
                border: 'none'
            }
        }}
>
  +
</Button>
</Box>
  </Box>
  <TableContainer component={Paper} sx={{ mb: 3 }}>
  <Table size="small">
    <TableHead sx={{ backgroundColor: "#e0eaff" }}>
      <TableRow  sx={{'& .MuiTableCell-head': { py: 0.1, fontSize: '12px', fontWeight: 500 } }}>
        <TableCell>ID</TableCell>
        <TableCell>Name</TableCell>
        <TableCell>Status</TableCell>
        <TableCell></TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
            {filterConstraints()
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((constraint, index) => (
        <TableRow key={index} sx={{ '& .MuiTableCell-body': { py: 0.2 } }}>
          <TableCell>{constraint.id}</TableCell>
          <TableCell>{constraint.name}</TableCell>
          <TableCell><StatusButton status={constraint.status}>{constraint.status}</StatusButton></TableCell>
          <TableCell>
                  <Stack direction="row" spacing={1}>
                    <IconButton
                      size="small"
                      onClick={() => handleEdit(constraint)}
                      sx={{ p: 0.5 }}
                    >
                      <EditIcon sx={{ height: "18px", width: "18px", color: "#666" }} />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleStatusUpdate(constraint)}
                      sx={{ p: 0.5 }}
                    >
                      <ChangeCircleIcon sx={{ height: "18px", width: "18px", color: getStatusColor(constraint.status) }} />
                    </IconButton>
                  </Stack>
                    </TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
        {filterConstraints().length > 10 && (
          <TablePagination
            rowsPerPageOptions={[10]}
            component="div"
            count={filterConstraints().length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            sx={{
              '.MuiTablePagination-toolbar': {
                minHeight: '40px',
              },
              '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
                fontSize: '12px',
              }
            }}
          />
        )}
</TableContainer>
<Modal
  open={constraintModalOpen}
  onClose={() => setConstraintModalOpen(false)}
  sx={{
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-end"
  }}
>
  <Box
    sx={{
      width: "350px",
      height: "100%",
      bgcolor: "background.paper",
      boxShadow: 24,
      p: 1,
      overflowY: "auto",
    '& .MuiInputBase-input': { // Add this style to reduce input font size
      fontSize: '0.875rem'
    },
    '& .MuiInputLabel-root': { // Add this style to reduce label font size
      fontSize: '0.875rem'
    },
    '& .MuiMenuItem-root': { // Add this style to reduce dropdown item font size
      fontSize: '0.875rem'
    }
    }}
  >
    <Typography mb={1.5} style={{font: 'bold', fontWeight: '600'}}>Add Constraint</Typography>
    
       <TextField
      fullWidth
      label="Name"
      value={constraintData.name}
      onChange={(e) => 
        {
          const newValue = e.target.value;
        handleInputChange4("name", newValue);}
      }
      sx={{ mb: 1.5 }}
      size="small"
    />
    <FormControl fullWidth sx={{ mb: 1.5 }} size="small">
      <InputLabel id="constraint-status-label" shrink={true}>Status</InputLabel>
      <Select
        labelId="constraint-status-label"
        value={constraintData.status}
        label="Status"
        onChange={(e) => handleInputChange4("status", e.target.value)}
        notched
      >
        <MenuItem value="Schedule">Schedule</MenuItem>
        <MenuItem value="Technical">Technical</MenuItem>
        <MenuItem value="Compliance">Compliance</MenuItem>
      </Select>
    </FormControl>
    
    <Button
      fullWidth
      onClick={() => handleSave(constraintData, setConstraintModalOpen, () => setConstraintData({
        id: "",
        type: "",
        description: "",
        impact: "",
        mitigation: "",
        status: "Active"
      }))}
      sx={{
        textTransform: "none",
        bgcolor: '#FF2800',
        color: 'white',
        mb: 0.5,
        "&:hover": { bgcolor: "#FF2800" }
      }}
    >
      Save
    </Button>
    
    <Button
      fullWidth
      onClick={() => setConstraintModalOpen(false)}
      sx={{ textTransform: "none", bgcolor: 'white', color: 'black' }}
    >
      Cancel
    </Button>
  </Box>
</Modal>
    </Container>
  )
}